import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import {
  HTMLSelect,
  Button,
  Intent,
  Spinner,
  NonIdealState,
} from "@blueprintjs/core";
import { parse as json2csv } from "json2csv";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import "../assets/components/Feedback.css";

import Session from "../services/Session";
import { base } from "../fire";

class Feedback extends React.Component {
  constructor() {
    super();
    this.state = { session: null, instances: [], loading: true };
  }

  downloadToCSV = () => {
    const { session, instances } = this.state;
    const data = Session.getFeedbackAnswersForSession(session, instances);
    const formatedData = [];
    let element = document.createElement("a");
    let file = null;

    data.forEach((feedbackResult) =>
      feedbackResult.answers.forEach((answerData) =>
        formatedData.push({
          sessionName: session.metadata.name,
          participant: answerData.participantId,
          answer: answerData.answer,
          sessionShortname: session.metadata.shortname,
          sessionProtocol: session.metadata.protocol,
          sessionType: session.metadata.type,
          feedback: feedbackResult.feedback.question,
        })
      )
    );
    file = new Blob([json2csv(formatedData)], { type: "text/csv" });
    element.href = URL.createObjectURL(file);
    element.download = `export_session_feedbacks_${session.id}`;
    element.click();
  };

  render() {
    const { instances = [], loading, session = {} } = this.state;
    let answers = null;

    if (loading) return <Spinner className="margin-top-medium" />;
    if (session == null)
      return (
        <NonIdealState
          icon="thumbs-down"
          title="Session introuvable"
          description="Nous n'avons pas pu trouver la session."
          action={
            <Link to="/">
              <Button
                text="Liste des sessions"
                intent={Intent.PRIMARY}
                rightIcon="properties"
              />
            </Link>
          }
        />
      );
    if (!session.data.feedbacks || session.data.feedbacks === 0)
      return (
        <NonIdealState
          icon="circle"
          title="Aucun feedback configuré"
          description="Cette session ne semble pas avoir de feedback configuré !"
          className="margin-top-medium"
        />
      );
    if (instances.length === 0)
      return (
        <NonIdealState
          icon="circle"
          title="Feedbacks indisponibles"
          description="Cette session semble ne pas diposer encore de feedbacks !"
          className="margin-top-medium"
        />
      );

    answers = Session.getFeedbackAnswersForSession(session, instances);
    return (
      <div className="row margin-top-medium">
        <div className="col-xs-12 text-right">
          <Button
            text="Exporter en CSV"
            style={{ marginBottom: "15px" }}
            onClick={this.downloadToCSV}
          />
        </div>
        <div className="col-xs-12">
          <FeedbackResultViewer answers={answers} />
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.sessionId = this.props.match.params.id;

    Session.getSessionById(this.sessionId).then((session) => {
      if (!session) return this.setState({ loading: false, session: null });
      this.setState({ session });
      this.syncSessionInstances = Session.syncSessionInstances(session.id, {
        context: this,
        state: "instances",
        asArray: true,
        then: () => this.setState({ loading: false }),
      });
    });
  }

  componentWillUnmount() {
    if (this.syncSessionInstances)
      base.removeBinding(this.syncSessionInstances);
  }
}

export class FeedbackResultViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentFeedback: null };
  }

  handleChangeFeedback = (e) => {
    const value = e.target.value;
    const { answers } = this.props;

    this.setState({
      currentFeedbackId: answers.find((answer) => answer.feedback.id === value)
        .feedback.id,
    });
  };

  render() {
    const { answers = [] } = this.props;
    const { currentFeedbackId } = this.state;
    const currentFeedback = answers.find(
      (answer) => answer.feedback.id === currentFeedbackId
    );

    if (currentFeedbackId == null || currentFeedback == null)
      return <div className="feedback-wrapper" />;
    return (
      <div className="feedback-wrapper">
        <div className="row">
          <div className="col-xs-12 col-sm-4 col-md-3">
            <div className="infos">
              <div className="feedback-select">
                <HTMLSelect
                  onChange={this.handleChangeFeedback}
                  value={
                    currentFeedback == null ? "" : currentFeedback.feedback.id
                  }
                >
                  <option value="" disabled={true}>
                    Choisir un feedback...
                  </option>
                  {answers.map((answer, index) => (
                    <option key={index} value={answer.feedback.id}>
                      {answer.feedback.question}
                    </option>
                  ))}
                </HTMLSelect>
              </div>
              <div className="question">
                {currentFeedback.feedback.question}
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-8 col-md-9">
            {currentFeedback.feedback.type === "OPEN" /** Use constant */ && (
              <FeedbackOpenResult result={currentFeedback} />
            )}
            {currentFeedback.feedback.type === "CLOSE" /** Use constant */ && (
              <FeedbackCloseResult result={currentFeedback} />
            )}
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    const { answers = [] } = this.props;

    if (answers.length)
      this.setState({ currentFeedbackId: answers[0].feedback.id });
  }
}

class FeedbackOpenResult extends React.Component {
  render() {
    const { result } = this.props;
    const { answers = [] } = result;

    return (
      <div className="result">
        {answers.map((answer, index) => {
          if (answer.answer !== "") {
            return (
              <Fragment key={index}>
                <div className="item" key={index}>
                  {/* <div className="participant">
              Participant{" "}
              <span className="highlight">{answer.participantId}</span>
            </div> */}
                  <div className="answer">"{answer.answer}"</div>
                </div>
                <hr className="light-hr" />
              </Fragment>
            );
          } else {
            return null;
          }
        })}
      </div>
    );
  }
}

class FeedbackCloseResult extends React.Component {
  render() {
    let data = [
      { name: "1", rate: 0 },
      { name: "2", rate: 0 },
      { name: "3", rate: 0 },
      { name: "4", rate: 0 },
      { name: "5", rate: 0 },
      { name: "6", rate: 0 },
      { name: "7", rate: 0 },
      { name: "8", rate: 0 },
      { name: "9", rate: 0 },
      { name: "10", rate: 0 },
    ];

    const { result } = this.props;
    this.props.result.answers.forEach((answer, i) => {
      data[answer.answer - 1] = {
        name: `${answer.answer.toString()}`,
        rate: `${(
          parseFloat(data[answer.answer - 1].rate) +
          (1 / result.answers.length) * 100
        ).toFixed(2)}`,
      };
    });

    return (
      <div className="result">
        <div className="resume text-center">
          <div className="subtitle">Moyenne</div>
          <div>{result.average} / 10</div>
          {/* <div className="criteria">
            {result.feedback.leftLegend} &middot; {result.feedback.rightLegend}
          </div> */}
        </div>
        <div style={{ width: "100%", height: 500 }}>
          <ResponsiveContainer>
            <BarChart
              width={800}
              height={300}
              data={data}
              padding={{ bottom: 40 }}
              margin={{
                top: 30,
                right: 40,
                left: 40,
                bottom: 25,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                label={{ value: "Rate", position: "insideBottom" }}
              />
              <YAxis
                domain={[0, 100]}
                interval={1}
                label="Votes % &emsp;&emsp;&emsp;&emsp;"
              />
              <Tooltip />
              {/* <Legend /> */}
              <Bar dataKey="rate" barSize={50} fill="#3563FB" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default Feedback;
